import React, { useCallback, useEffect, useState } from "react";
import styles from "./Table.module.sass";
import Row from "./Row";
import { FETCH_SYNC_HISTORY } from "../../../../../../API/Store";
import { ConfigProvider, Pagination } from "antd";
import CustomToast from "../../../../../../components/CustomToast";
import Card from "../../../../../../components/Card";
import cn from "classnames";
import useDarkMode from "use-dark-mode";

const Table = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const savedPageSize = localStorage.getItem("itemsPerPage");
    return savedPageSize ? parseInt(savedPageSize, 10) : 10;
  });

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const queryParams = [
        { key: "page", value: page },
        { key: "pageSize", value: itemsPerPage },
      ];
      const response = await FETCH_SYNC_HISTORY(queryParams);
      if (response && response.result && Array.isArray(response.result)) {
        setData(response.result);
        setTotalItems(response.count || 0);
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      CustomToast.fire({
        icon: "error",
        text: error.message || "Error fetching data",
      });
      setData([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [page, itemsPerPage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handlePageSizeChange = (current, size) => {
    setItemsPerPage(size);
    setPage(1);
    localStorage.setItem("itemsPerPage", size.toString());
  };

  const darkMode = useDarkMode(false);
  const themeConfig = {
    token: {
      colorPrimary: "#1890ff",
      colorTextBase: darkMode.value ? "#ffffff" : "#000000",
      colorBgContainer: darkMode.value ? "#1f1f1f" : "#ffffff",
      colorBgElevated: darkMode.value ? "#2f2f2f" : "#ffffff",
      colorText: darkMode.value ? "#ffffff" : "#000000",
    },
  };

  return (
    <ConfigProvider theme={themeConfig}>
      <div className={styles.market}>
        <Card className={styles.card}>
          <div className="overflow-auto">
            <div className={styles.table}>
              <div className={styles.row}>
                {/* <div className={cn( styles.col)}>
                  Id
                </div> */}
                <div className={cn("whitespace-nowrap", styles.col)}>
                  Sync Type
                </div>
                <div className={cn("whitespace-nowrap ", styles.col)}>
                  Number of records
                </div>
                <div className={cn("whitespace-nowrap ", styles.col)}>
                  Synced By
                </div>
                <div className={cn("whitespace-nowrap ", styles.col)}>Date</div>
                <div className={cn("whitespace-nowrap ", styles.col)}>
                  Status
                </div>
              </div>
              {data.map((item) => (
                <Row key={item.id} data={item} />
              ))}
            </div>
          </div>

          <div className={styles.foot}>
            <Pagination
              current={page}
              total={totalItems}
              pageSize={itemsPerPage}
              onChange={handlePageChange}
              onShowSizeChange={handlePageSizeChange}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} orders`
              }
              showSizeChanger
            />
          </div>
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default Table;
